import React from "react";
import ReactDOM from "react-dom/client";

// Import the new AppShell (with sidebar + routing)
import AppShell from "./AppShell";

// Keep your existing CSS
import "./App.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppShell />
  </React.StrictMode>
);
